import axios from 'axios';

import store from '../../redux';
import { setTenantError } from '../../redux/tenant/tenant.actions';
import { getTenantSlug } from '../../utils/tenant';

// Instância única de axios para TODAS as chamadas às rotas públicas de
// chat da API -- Task 8b (tenancy-foundation). Centraliza duas coisas que
// antes cada call site fazia (ou esquecia de fazer) por conta própria:
//
//   1) Envia o slug do tenant (`X-Tenant-Slug`) em toda requisição, para
//      que `ResolveTenantFromChat` (API) resolva a empresa correta. Ver
//      utils/tenant.js para como o slug é resolvido a partir da rota.
//   2) Detecta quando a API respondeu com uma falha de resolução de
//      tenant (400 sem slug/sala, 404 tenant não encontrado/inativo ou
//      sala de outro tenant) e propaga isso para o redux, para a tela
//      trocar por uma mensagem amigável em vez de deixar cada tela
//      quebrar/ficar em branco silenciosamente.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost/alodesk-chat-api/public';

const httpClient = axios.create({
  baseURL: API_BASE_URL
});

httpClient.interceptors.request.use((config) => {
  const slug = getTenantSlug();
  if (slug) {
    config.headers = { ...(config.headers || {}), 'X-Tenant-Slug': slug };
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const message = (error.response && error.response.data && error.response.data.message) || '';

    // As três mensagens que `ResolveTenantFromChat` devolve mencionam
    // "tenant" ou "empresa" -- checagem por conteúdo (em vez de status cru)
    // para não confundir com outros 400/404 legítimos da API (ex.:
    // validação de formulário, sala não encontrada por outro motivo).
    if ((status === 400 || status === 404) && /tenant|empresa/i.test(message)) {
      const friendlyMessage = status === 404
        ? 'Empresa não encontrada. Verifique o link de atendimento utilizado.'
        : 'Não foi possível identificar a empresa para este atendimento. Atendimento indisponível no momento.';

      store.dispatch(setTenantError(friendlyMessage));
    }

    return Promise.reject(error);
  }
);

export default httpClient;
